// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { IEnvironment } from '@shared/interfaces/various/IEnvironment';
import { Module } from '@shared/enums/Module';

export const environment: IEnvironment = {
    production: false,
    appVersion: require('../../../../package.json').version,
    scdApiKey: 'tRyzcRl5N25VgoF0XAY7398ZNkgsQJB30fffF1R9',
    projectConfiguration: {
        availableLanguages: ['en', 'de'],
        modules: [
            Module.Glossary,
            Module.Hyperlinks,
            Module.Reports,
            Module.ReportTemplates,
            Module.SummaryReports,
            Module.Organisation,
            Module.CascadedReporting,
            Module.Mailing,
            Module.Faq
        ]
    }
};
